import type { ProdConfig } from '@/config/config'

export const configStaging: Partial<ProdConfig> = {
  env: 'prod',
  featureFlags: {
    // [FeatureFlags.FooBar]: isStaging(),
  },
}
